import { useCallback, useEffect, useState } from 'react'

import { ddPanelMainAccountAPI } from '../api/services/dd_panel_main_accounts'
import {
  GlobalResponse,
  SubaccountStats
} from '../api/services/dd_panel_main_accounts/types.ts'

export const useGlobalStatistics = (start_date: string, end_date: string) => {
  const [loading, setLoading] = useState<boolean>(true)
  const [error, setError] = useState<string | null>(null)
  const [data, setData] = useState<GlobalResponse | null>(null)

  const [refreshIndex, setRefreshIndex] = useState(0)

  const refetch = useCallback(() => {
    setRefreshIndex((index) => index + 1)
  }, [])

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await ddPanelMainAccountAPI.getGlobalSalesStatistics(
          start_date,
          end_date
        )

        if (response.error) {
          setError(response.error)
          setLoading(false)
          return
        }

        const data = response.data

        if (data) {
          setData(data)
        }
      } catch {
        setError('Coś poszło nie tak, spróbuj później')
      } finally {
        setLoading(false)
      }
    }

    fetchData()
  }, [refreshIndex])

  return { data, loading, error, refetch }
}

export const useSubaccountsSalesStatistics = (
  start_date: string,
  end_date: string
) => {
  const [loading, setLoading] = useState<boolean>(true)
  const [error, setError] = useState<string | null>(null)
  const [data, setData] = useState<SubaccountStats[] | null>(null)

  const [refreshIndex, setRefreshIndex] = useState(0)

  const refetch = useCallback(() => {
    setRefreshIndex((index) => index + 1)
  }, [])

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response =
          await ddPanelMainAccountAPI.getSubaccountsSalesStatistics(
            start_date,
            end_date
          )

        if (response.error) {
          setError(response.error)
          setLoading(false)
          return
        }

        const data = response.data

        if (data) {
          setData(data)
        }
      } catch {
        setError('Coś poszło nie tak, spróbuj później')
      } finally {
        setLoading(false)
      }
    }

    fetchData()
  }, [refreshIndex])

  return { data, loading, error, refetch }
}
